import { memo } from 'react';
import { Link } from 'react-router-dom';

import classnames from 'classnames';

import styles from './styles.module.scss';

function ButtonLink({ to, children, color = 'primary', size = 'small', variant = 'filled' }) {
  return (
    <>
      {to && (
        <Link
          to={to}
          className={classnames(
            styles['button-link'],
            styles[`button-link_${color}`],
            styles[`button-link_${size}`],
            styles[`button-link_${variant}`]
          )}
          color={color}
          size={size}
          variant={variant}>
          {children}
        </Link>
      )}
    </>
  );
}

export default memo(ButtonLink);
